import Footer from '@package/components/Footer';

export default Footer;
